import { TransferAssetApproverResolverBase } from './transfer-asset-approver.resolver.base';
import { TransferAssetApproverService } from './transfer-asset-approver.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class TransferAssetApproverResolver extends TransferAssetApproverResolverBase {

  constructor(protected service: TransferAssetApproverService) {
    super(service);
  }
}



